export function extractErrorMessage(error, fallbackMessage = "Something went wrong.") {
  if (typeof error === "string") {
    return error;
  }
  if (error?.error) {
    return error.error;
  }
  if (error?.message) {
    return error.message;
  }
  if (error?.response?.data?.error) {
    return error.response.data.error;
  }
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }
  if (Array.isArray(error?.response?.data?.errors)) {
    return error.response.data.errors.join(", ");
  }
  return fallbackMessage;
}
